import React from "react";
import { useTranslation } from "react-i18next";


const PrivateAmenities: React.FunctionComponent<{ property: any, errors: any, onchangePrivateAmenities: any }> = (props) => {

    const privateAmenitiesList = [
        "Central A/C & Heating", "Build - in Kitchen Appliances", "View of Landmark",
        "TV Cables & Wifi", "View of Water", "Covered Parkings", "Build - in Wardrobes",
        "Concierge Service", "Lobby in Building", "Walk - in Closet", "Maid’s Room", "Maid Service",
        "Pets Allowed", "Private Garden", "Children’s Pool", "Private Jacuzzi", "Private Pool",
        "Private Gym", "Vastu - compliant", "Barbecue Area", "Security", "Shared Pool", "Shared Spa",
        "Study", "Children's Play Area", "Balcony", "Shared Gym"
    ];

    const privateFrance = [
        "Wheelchair accessible", "Elevator", "Flooring: Parquet", "Private entrance",
        "Balcony", "Nice view, Not overlooked", "Parking box", "Intercom",
        "Keypad access", "Quiet", "West-facing", "Separate kitchen",
        "Cellar", "Nice view", "Caretaker"]

    const { t } = useTranslation();


    const handleChangePrivateAmenities = (value: any) => {
        props.onchangePrivateAmenities(value)
    }

    const isFrance = props.property && props.property.address && props.property.address.country === "FR";

    return (
        <>
            {isFrance ?
                <div className={`card-form mb-4 ${props.errors.privateAmenities ? 'input-error' : ''}`}>
                    <div className="amenities-grid">
                        {privateFrance.map((amenity, index) => (
                            <div key={index} className="form-check mb-2">
                                <input
                                    id={`check-${index}-${amenity}`}
                                    type="checkbox"
                                    className="form-check-input"
                                    name={`check-${index}-${amenity}`}
                                    onChange={() => handleChangePrivateAmenities(amenity)}
                                    checked={props.property.privateAmenities?.includes(amenity) || false}
                                />
                                <label className="form-check-label">{t(`amenitiesList.${amenity}`)}</label>
                            </div>
                        ))}
                    </div>
                </div> : <div className={`card-form mb-4 ${props.errors.privateAmenities ? 'input-error' : ''}`}>
                    <div className="amenities-grid">
                        {privateAmenitiesList.map((amenity, index) => (
                            <div key={index} className="form-check mb-2">
                                <input
                                    id={`check-${index}-${amenity}`}
                                    type="checkbox"
                                    className="form-check-input"
                                    name={`check-${index}-${amenity}`}
                                    onChange={() => handleChangePrivateAmenities(amenity)}
                                    checked={props.property.privateAmenities?.includes(amenity) || false}
                                />
                                <label className="form-check-label">{t(`amenitiesList.${amenity}`)}</label>
                            </div>
                        ))}
                    </div>
                </div>}
        </>
    )
}

export default PrivateAmenities;